import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TransactionMenuComponent } from './transaction-menu.component';
const routes: Routes = [{ path: '', component: TransactionMenuComponent }];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionMenuRoutingModule { }
